import { render, staticRenderFns } from "./global_catalog.vue?vue&type=template&id=51113a9a"
import script from "./global_catalog.vue?vue&type=script&lang=js"
export * from "./global_catalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports